import fp from 'lodash/fp'
import { withStore, createAction } from 'common/src/vtj/mobx/action-creator'
import { TodistuksetUi } from 'todistukset-ui/src/vtj/common-types'
import OrderFlowName from 'todistukset-ui/src/vtj/OrderFlowName.enum'

export const clearVisitsAfterCurrentStep = (
  orderFlowName: OrderFlowName
): void =>
  createAction((store: TodistuksetUi.Store) => {
    const stepData = store.steps[orderFlowName]
    const begin = stepData.currentStep + 1
    const end = stepData.stepCount
    const range = fp.range(begin, end)
    fp.forEach((index) => {
      if (store.steps[orderFlowName].visitedSteps[index]) {
        store.steps[orderFlowName].visitedSteps[index] = false
      }
    }, range)
  })

export const clearVisitedSteps = (orderFlowName: OrderFlowName): void => {
  createAction((store: TodistuksetUi.Store) => {
    const stepCount = store.steps[orderFlowName].stepCount
    Array(stepCount)
      .fill(0)
      .forEach((_, index) => {
        if (store.steps[orderFlowName].visitedSteps[index]) {
          store.steps[orderFlowName].visitedSteps[index] = false
        }
      })
  })
}

export const setCurrentStepIndex = (
  orderFlowName: OrderFlowName,
  stepIndex: number
): void =>
  createAction((store: TodistuksetUi.Store) => {
    store.steps[orderFlowName].currentStep = stepIndex
    store.steps[orderFlowName].visitedSteps[stepIndex] = true
  })

export const setAllStepsVisited = (orderFlowName: OrderFlowName): void =>
  createAction((store: TodistuksetUi.Store) => {
    for (let i = 0; i < store.steps[orderFlowName].stepCount; i++) {
      store.steps[orderFlowName].visitedSteps[i] = true
    }
  })

export const getVisitedStepsData = (
  orderFlowName: OrderFlowName
): boolean[] => {
  return withStore(
    (store: TodistuksetUi.Store) => store.steps[orderFlowName].visitedSteps
  )
}

export const setShowValidationErrors = ({
  orderFlowName,
  value,
}: {
  orderFlowName: OrderFlowName
  value: boolean
}): void => {
  createAction((store: TodistuksetUi.Store) => {
    store.steps[orderFlowName].showStepValidationErrors = value
  })
}
